import {
  CRUDLayout
} from "components"
import {
  ButtonBack,
  DataStatus
} from "components2"
import { Form, Formik } from "formik"
import { useEffect, useState } from "react"
import { Card } from "react-bootstrap"
import { useParams } from "react-router-dom"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import { ListPerubahanData, ModalDetailItemPerubahanData } from "./components"
import { DetailPermintaanPerubahanData } from "./components/DetailPermintaanPerubahanData"
import { useGetSinglePermintaanPerubahanData } from "./hooks"

export const PermintaanPerubahaDataDetail = ({ setNavbarTitle }) => {
  const history = useHistory()
  const { id_permintaan_perubahan_data_master } = useParams()
  const [modal, setModal] = useState({
    type: "CREATE",
    show: false,
    data: null,
    index: null
  })
  const detail = useGetSinglePermintaanPerubahanData({ id_permintaan_perubahan_data_master })
  const data = detail.data?.data?.data

  const dismissModal = (resetForm) => {
    if (resetForm) resetForm()

    setModal({ data: null, index: null, show: false, type: "" })
  }

  const formInitialValues = {
    tgl_permintaan_perubahan_data_master: data?.tgl_permintaan_perubahan_data_master,
    no_permintaan_perubahan_data_master: data?.no_permintaan_perubahan_data_master,
    urgensi: data?.urgensi,
    deskripsi: data?.deskripsi,
    detail: data?.detail,
    status: data?.status
  }

  useEffect(() => setNavbarTitle("Permintaan Perubahan Data"), [])

  return (
    <CRUDLayout>
      <CRUDLayout.Head>
        <CRUDLayout.HeadButtonSection>
          <ButtonBack size="md" icon onClick={() => history.goBack()} />
        </CRUDLayout.HeadButtonSection>
      </CRUDLayout.Head>

      {detail?.isLoading ? (
        <Card className="mt-4">
          <Card.Body>
            <DataStatus loading loadingText="Memuat data..." />
          </Card.Body>
        </Card>

      ) : (
        <Formik
          enableReinitialize
          initialValues={formInitialValues}
        >
          {
            ({ values }) => {
              return (
                <Form>
                  <Card className="mt-4">
                    <Card.Body>
                      <DetailPermintaanPerubahanData />
                    </Card.Body>
                  </Card>

                  <Card className="mt-4">
                    <Card.Header className="font-weight-bold">List Perubahan Data</Card.Header>
                    <Card.Body>
                      <ListPerubahanData
                        showDetailButton
                        showDeleteButton={false}
                        showUpdateButton={false}
                        data={values.detail}
                        onClickDetail={(data, index) => setModal({ show: true, type: "DETAIL", data, index })}
                      />
                    </Card.Body>
                  </Card>

                  <ModalDetailItemPerubahanData
                    modal={modal}
                    dismissModal={dismissModal}
                  />
                </Form>
              )
            }}
        </Formik >
      )}
    </CRUDLayout >
  )
}
